import AdminPage from 'pages/Admin';
import AdminRoute from 'components/AdminRoute/AdminRoute.tsx';
import PageLayout from 'components/layouts/PageLayout.tsx';
import AdminSelectTeamPage from 'pages/admin/AdminSelectTeamPage.tsx';
import AdminTeamCohortsPage from 'pages/admin/TeamCohortsPage/TeamCohortsPage.tsx';
import AdminReviewTeamCohortsPage from 'pages/admin/TeamCohortsPage/ReviewTeamCohortsPage.tsx';
import TeamCohortsConfirmationPage from 'pages/admin/TeamCohortsPage/TeamCohortsConfirmationPage';
import TeamRoutingPlansPage from 'pages/admin/TeamRoutingPlansPage/TeamRoutingPlansPage';
import AddRoutingPlansPage from 'pages/admin/TeamRoutingPlansPage/AddRoutingPlansPage';
import ManageUserDetailsPage from 'pages/admin/ManageUserDetails/ManageUserDetailsPage.tsx';
import SelectUserPage from 'pages/admin/ManageUserDetails/SelectUserPage.tsx';
import EditUserDetailsPage from 'pages/admin/ManageUserDetails/EditUserDetailsPage.tsx';
import EditUserDetailsConfirmationPage from 'pages/admin/ManageUserDetails/EditUserDetailsConfirmationPage.tsx';
import EditUserPermissionsPage from 'pages/admin/ManageUserDetails/EditUserPermissionsPage.tsx';
import EditUserPermissionsConfirmationPage from 'pages/admin/ManageUserDetails/EditUserPermissionsConfirmationPage.tsx';
import CampaignTemplatesPage from 'pages/admin/CampaignTemplates/CampaignTemplatesPage.tsx';
import TeamRoutingPlansConfirmationPage from 'pages/admin/TeamRoutingPlansPage/TeamRoutingPlansConfirmationPage';
import ChangeTargetsConfirmationPage from 'pages/admin/TeamRoutingPlansPage/ChangeTargetsConfirmationPage';
import ChangeTargetsPage from 'pages/admin/TeamRoutingPlansPage/ChangeTargetsPage';
import { directAccessGuardLoader } from 'routes/DirectAccessGuard';

const adminRoutes = [
  {
    loader: directAccessGuardLoader,
    // Saving team cohorts or routing plans navigates to a confirmation page.
    // Don't rerun the guard on that navigation; it should only redirect direct visits to those pages.
    // See https://reactrouter.com/6.30.1/route/should-revalidate
    shouldRevalidate: () => false,
    path: '',
    element: <PageLayout />,
    children: [
      {
        path: 'admin',
        handle: { breadcrumb: 'Admin home' },
        children: [
          {
            index: true,
            element: (
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            ),
          },
          {
            path: 'select-team',
            handle: { breadcrumb: 'Choose team' },
            element: (
              <AdminRoute>
                <AdminSelectTeamPage />
              </AdminRoute>
            ),
          },
          {
            path: ':teamId',
            children: [
              {
                path: 'team-cohorts',
                element: (
                  <AdminRoute requiredRole=":cohort_admin">
                    <AdminReviewTeamCohortsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-cohorts/edit',
                element: (
                  <AdminRoute requiredRole=":cohort_admin">
                    <AdminTeamCohortsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-cohorts/confirmation',
                element: (
                  <AdminRoute requiredRole=":cohort_admin">
                    <TeamCohortsConfirmationPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-message-plans',
                element: (
                  <AdminRoute requiredRole=":routing_plan_admin">
                    <TeamRoutingPlansPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-message-plans/add',
                element: (
                  <AdminRoute requiredRole=":routing_plan_admin">
                    <AddRoutingPlansPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-message-plans/change-targets',
                element: (
                  <AdminRoute requiredRole=":routing_plan_admin">
                    <ChangeTargetsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-message-plans/confirmation',
                element: (
                  <AdminRoute requiredRole=":routing_plan_admin">
                    <TeamRoutingPlansConfirmationPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'team-message-plans/change-targets/confirmation',
                element: (
                  <AdminRoute requiredRole=":routing_plan_admin">
                    <ChangeTargetsConfirmationPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/select-user',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <SelectUserPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/user/:userId',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <ManageUserDetailsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/user/:userId/details',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <EditUserDetailsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/user/:userId/details/confirmation',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <EditUserDetailsConfirmationPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/user/:userId/permissions',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <EditUserPermissionsPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'manage-user-details/user/:userId/permissions/confirmation',
                element: (
                  <AdminRoute requiredRole=":team_admin">
                    <EditUserPermissionsConfirmationPage />
                  </AdminRoute>
                ),
              },
              {
                path: 'campaign-templates',
                element: (
                  <AdminRoute requiredRole=":campaign_template_admin">
                    <CampaignTemplatesPage />
                  </AdminRoute>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];

export default adminRoutes;
